import FieldShow from "@/components/FieldShow.vue";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	data() {
		return {
			loadings: {
				main: false,
			},
			hasGetData: false,
			tableData: [],
			paginations: {
				main: {
					pageNow: 1,
					total: 0,
				},
			},
			sorts: {
				sortKey: "_id",
				sortOrder: "desc",
			},
			fieldsShow: [],
			checks: [],
			isIndeterminate: false,
			isCheckAll: false,
		};
	},
	props: {
		dataModel: {
			type: String,
			default: "",
		},
		autoLoad: {
			type: Boolean,
			default: true,
		},
		kvFilter: {
			type: Object,
			default: function() {
				return {};
			},
		},
		hasExpandShow: {
			type: Boolean,
			default: false,
		},
		expandFields: {
			type: Array,
			default: function() {
				return [];
			},
		},

		listUrl: {
			type: String,
			default: "",
		},
		deleteUrl: {
			type: String,
			default: "",
		},
		listOps: {
			type: Array,
			default: function() {
				return [
					{
						name: "edit",
						show_name: "编辑",
						handler: "doedit",
					},
				];
			},
		},
		hasDelete: {
			type: Boolean,
			default: true,
		},
		infoLink: {
			type: String,
			default: "",
		},
		infoField: {
			type: String,
			default: "",
		},
		hasOpSlot: {
			type: Boolean,
			default: false,
		},
		hasPage: {
			type: Boolean,
			default: true,
		},
		perPage: {
			type: Number,
			default: 50,
		},
		isSelectable: {
			type: Boolean,
			default: false,
		},
		searchFilter: {
			type: String,
			default: "",
		},
		colorFilter: {
			type: String,
			default: "",
		},
		dateFilter: {
			type: Array,
		},
		showSummary: {
			type: Boolean,
			default: false,
		},
		sortBy: {
			type: Object,
			default() {
				return {
					sortKey: "updated_at",
					sortOrder: "desc",
				};
			},
		},
		hoverIndex: -1,
		hasFilter: {
			type: Boolean,
			default: true,
		},
		warehouseFilter: {
			type: Object,
			default: function () {
				return {
					_id: "",
				};
			},
		},
		batchOps: {
			type: Array,
		},
	},
	computed: {
		...mapState(["dataModels", "loadingDM", "userPrivilegeMapping"]),
		hasGetTableDataModel() {
			if (this.dataModels[this.dataModel] && this.dataModels[this.dataModel]._id) {
				return true;
			} else {
				return false;
			}
		},
		realFields() {
			let fieldShowFilter = {};
			this.fieldsShow.forEach(val => {
				fieldShowFilter[val] = 1;
			});
			return this.fields.filter(key => {
				if (key.privilege) {
					let orHavePri = false;
					key.privilege.forEach(pri => {
						if (this.userPrivilegeMapping[pri]) {
							orHavePri = true;
						}
					});

					if (!orHavePri) {
						return false;
					}
				}

				if (!fieldShowFilter[key.name]) {
					return false;
				}
				return true;
			});
		},
		realExpandFields() {
			return this.expandFields.filter(key => {
				if (key.name == "cost_per" && !this.userPrivilegeMapping[59]) {
					return false;
				}
				return true;
			});
		},
		dm() {
			const dm = JSON.parse(JSON.stringify(this.dataModels[this.dataModel]));
			for (const field of this.realFields) {
				if (!dm[field.name]) {
					if (!field.fieldInfo) {
						dm[field.name] = {
							name:field.name,
							show_name:field.name,
							type:'Field_string',
							default: ""
						};
					} else {
						dm[field.name] =  JSON.parse(JSON.stringify(field.fieldInfo));
					}
				} else {
					if (field.fieldInfo) {
						dm[field.name] = Object.assign(dm[field.name],field.fieldInfo);
					}
				}
			}
			return dm;
		}
	},
	created() {},
	mounted() {
		this.refreshDataModel();
		this.sorts = Object.assign({}, this.sortBy);
		this.getShowFields();
	},
	methods: {
		...mapMutations(["checkDataModel"]),
		handleCheckAllChange() {
			this.checks.forEach((v, k) => {
				this.$set(this.checks, k, !v);
			});
			this.isIndeterminate = false;
			// this.isCheckAll = true;
		},
		handleCheck(index) {
			// this.$set(this.checks,index,!this.checks[index]);

			let checks = this.checks.filter(val => {
				return val;
			});
			if (checks.length == this.checks.length) {
				this.isIndeterminate = false;
				this.isCheckAll = true;
			} else if (checks.length > 0) {
				this.isIndeterminate = true;
				this.isCheckAll = false;
			} else {
				this.isIndeterminate = false;
				this.isCheckAll = false;
			}
		},
		handleClickBatchOp(key) {
			this.$emit("click-batch-op", key, this.checks);
		},
		getShowFields() {
			let key = "show_fields_" + this.$route.path;
			//为了新增字段兼容性，这里存所有关掉的,而不是打开的
			let cache = {};
			if (localStorage.getItem(key)) {
				cache = JSON.parse(localStorage.getItem(key));
			}
			this.fieldsShow = this.fields
				.filter(val => {
					if (cache[val.name]) {
						return false;
					}
					if (val.name == "cost_per" && !this.userPrivilegeMapping[59]) {
						return false;
					}
					return true;
				})
				.map(val => {
					return val.name;
				});
			localStorage.setItem(key, JSON.stringify(cache));
		},
		handleMouseEnter(row, column, cell, event) {
			debugger;
		},
		handleMouseOut(row, column, cell, event) {
			debugger;
		},
		formatter(row, column) {
			return row.supplier;
		},
		filterTag(value, row) {
			return row.tag === value;
		},
		filterHandler(value, row, column) {
			const property = column["property"];
			return row[property] === value;
		},
		refreshDataModel() {
			if (this.dataModel) {
				this.checkDataModel(this.dataModel);
			}
		},
		setData(datas) {
			this.tableData = [];
			this.checks = [];
			for (let k in datas) {
				this.tableData.push(datas[k]);
				this.checks.push(false);
			}
			this.hasGetData = true;
			this.isIndeterminate = false;
			this.isCheckAll = false;
		},
		setPageTotal(total) {
			this.paginations.main.total = total;
		},
		refreshData() {
			this.loadings.main = true;
			const url = this.listUrl ? "/" + this.listUrl : `/curd/lists/${this.dataModel}`;
			this.$axios
				.post(url, {
					page: this.hasPage ? this.paginations.main.pageNow : -999,
					perPage: this.perPage,
					sortKey: this.sorts.sortKey,
					sortOrder: this.sorts.sortOrder,
					searchFilter: this.searchFilter,
					dateFilter: this.dateFilter,
					kvFilter: this.kvFilter,
					warehouseFilter:this.warehouseFilter._id
				})
				.then(json => {
					this.loadings.main = false;
					
					this.$emit("change", json.data.datas);
					this.$emit("gettotal", json.data.pages.total);
					this.setData(json.data.datas);
					this.setPageTotal(json.data.pages.total);
				})
				.catch(json => {
					this.loadings.main = false;
				});
		},
		handleSelectionChange(val) {
			this.$emit("selectChange", val);
		},
		handleDelete(id) {
			this.loadings.main = true;
			this.$confirm("将永久删除该条目, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const url = this.deleteUrl
						? `/${this.deleteUrl}/${id}`
						: `/curd/do_delete/${this.dataModel}/${id}`;

					this.$axios
						.post(url, { id: id })
						.then(json => {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.loadings.main = false;
							this.refreshData();
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.loadings.main = false;

					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		handleSortChange({ column, prop, order }) {
			if (order == "ascending") {
				order = "asc";
			} else if (order == "descending") {
				order = "desc";
			} else {
			}
			this.sorts.sortKey = prop;
			this.sorts.sortOrder = order;

			if (!this.autoLoad) {
				//无需加载的，只需要告诉外面变了
				//其他的本就外面处理，只需要处理 sort 和 page
				this.$emit("refresh", {
					sortKey: this.sorts.sortKey,
					sortOrder: this.sorts.sortOrder,
					page: this.hasPage ? this.paginations.main.pageNow : -999,
				});
				return;
			}
			this.refreshData();
		},
		handlePageChange(pageNow) {
			this.paginations.main.pageNow = pageNow;
			if (!this.autoLoad) {
				//无需加载的，只需要告诉外面变了
				//其他的本就外面处理，只需要处理 sort 和 page
				this.$emit("refresh", {
					sortKey: this.sorts.sortKey,
					sortOrder: this.sorts.sortOrder,
					page: this.hasPage ? this.paginations.main.pageNow : -999,
				});
				return;
			}
			this.refreshData();
		},
		handleClick(dataIndex, opIndex) {
			let op = this.listOps[opIndex];
			this.$emit(op.handler, this.tableData[dataIndex]._id, this.tableData[dataIndex]);
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				let fieldName = column.property;

				if (index === 0) {
					sums[index] = "总计";
					return;
				}
				if (!this.dataModels[this.dataModel][fieldName]) {
					sums[index] = "";
					return;
				}

				if (
					this.dataModels[this.dataModel][fieldName].type != "Field_money" &&
					this.dataModels[this.dataModel][fieldName].type != "Field_int" &&
					this.dataModels[this.dataModel][fieldName].type != "Field_float"
				) {
					sums[index] = "";
					return;
				}

				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value))) {
					if (this.dataModels[this.dataModel][fieldName].type == "Field_money") {
						sums[index] = this.$root.currencyCode + sums[index];
					}
					sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);
				} else {
					sums[index] = "N/A";
				}
			});

			return sums;
		},
	},
	watch: {
		fieldsShow(val) {
			//cache存关掉的
			let cache = {};
			this.fields.forEach(val => {
				cache[val.name] = 1;
			});
			this.fieldsShow.forEach(val => {
				delete cache[val];
			});
			let key = "show_fields_" + this.$route.path;
			localStorage.setItem(key, JSON.stringify(cache));
		},
		hasGetTableDataModel: {
			handler(val) {
				if (val) {
					if (this.autoLoad) {
						this.refreshData();
					}
				}
			},
			immediate: true,
		},
		kvFilter: {
			handler(val) {
				if (val) {
					this.paginations.main.pageNow = 1;
					this.refreshData();
				}
			},
			immediate: false,
			deep: true,
		},
		searchFilter: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					this.refreshData();
				}
			},
			immediate: false,
		},
		colorFilter: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					this.refreshData();
				}
			},
			immediate: false,
		},
		dateFilter: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					this.refreshData();
				}
			},
			immediate: false,
		},
	},
	components: {
		FieldShow,
	},
};
